import { useEffect } from 'react';

import { getRawLocalStorage } from 'helpers/getRawLocalStorage';

import { isNil } from 'lodash-es';

export function useSanity() {
  useEffect(() => {
    if (import.meta.env.DEV) {
      const appId = getRawLocalStorage('appId');

      if (!isNil(appId) && appId !== import.meta.env.VITE_APP_ID) {
        localStorage.clear();
        window.location.href = '/login';
      }
    }
  }, []);
}
